import Vue from 'vue/dist/vue.esm'
import device from 'current-device'

let scrollToTop

Vue.directive('m-android-focus', {
  bind(el) {
    scrollToTop = () => {
      let y = (window.cfs.offset(el).top) - 90
      window.scrollTo({ top: y, behavior: 'smooth' })
    }
    if (device.androidPhone()) {
      el.addEventListener('click', scrollToTop)
    }
  },
  unbind(el) {
    if (device.androidPhone() && el) {
      el.removeEventListener('click', scrollToTop)
    }
  }
})